import { QueryParamProvider } from '../ports/QueryParamProvider';
import { AbTestingProvider } from '../ports/AbTestingProvider';
import { FastLaneProvider } from '../ports/FastLaneProvider';
import { MetaItem } from '../../entities/MetaItem';

export class BuildMetaArrayUseCase {
  constructor(
    private readonly queryParamProvider: QueryParamProvider,
    private readonly abTestingProvider: AbTestingProvider,
    private readonly fastLaneProvider: FastLaneProvider
  ) {}

  private createItem(
    type: MetaItem['type'],
    name: string,
    value: string | null | undefined,
    fallback = 'default'
  ): MetaItem {
    return { type, name, value: value ?? fallback };
  }

  execute(): MetaItem[] {
    const queryItems = this.buildFromQueryParams();
    const abTestItems = this.buildFromAbTests();
    const fastLaneItems = this.buildFromFastLane();

    return [...queryItems, ...abTestItems, ...fastLaneItems];
  }

  private buildFromQueryParams(): MetaItem[] {
    const params = this.queryParamProvider.getAll();

    return Object.entries(params)
      .filter(([_, value]) => value !== null && value !== 'undefined')
      .map(([key, value]) => this.createItem('query_parameter', key, value));
  }

  private buildFromAbTests(): MetaItem[] {
    const scenarios = this.abTestingProvider.getAll();

    return Object.entries(scenarios).map(([key, value]) => this.createItem('ab_test', key, value));
  }

  private buildFromFastLane(): MetaItem[] {
    const fastLane = this.fastLaneProvider.getFastLane();
    if (!fastLane) return [];

    return [
      this.createItem(
        'ab_test',
        fastLane.experimentId ?? 'fastLane',
        fastLane.fastLaneEnabled ? 'true' : 'false',
        'false'
      )
    ];
  }
}
